// extracted by css-extract-rspack-plugin
export default {"content":"EjCiLXhfh38rh2Y5","jsonBlock":"W7hKFY8s918IhDZ6","copyButton":"rITK4LKlXewoMZFp","jsonPre":"FXjqbIrae0oxDqpD"};